import Vue from 'vue';
import Vuex from 'vuex';
import storage from 'local-storage-fallback';
import config from '@/config';
import { version } from '../../package.json';

if (!('localStorage' in window)) {
  window.localStorage = storage;
}

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    config,
    version: '',
    bearer: '',
    user: null,
    loginState: {
      verify: false,
      banned: false,
      code: false
    },
    timestamp: {
      now: null,
      banned: null,
      interval: null
    }
  },
  mutations: {
    setUser (state, user) {
      const workState = state;
      workState.user = user;
    },
    updateNowTimestamp (state, timestamp) {
      const workState = state;
      workState.timestamp.now = timestamp;
    },
    setBearer (state, bearer) {
      const workState = state;
      workState.bearer = bearer;
    },
    setLoginState (state, loginState) {
      const workState = state;
      workState.loginState = loginState;
      if (loginState.banned) {
        workState.timestamp.banned = new Date().getTime() + config.timestamp.timeToBan;
      }
    },
    startTimer (state) {
      const wrkState = state;
      // Updating timeStamp to trigger state change;
      wrkState.timestamp.interval = setInterval(() => {
        this.commit('updateNowTimestamp', new Date().getTime());
      }, config.timestamp.refreshFrequency);
    },
    initialiseStore (state) {
      const wrkState = state;

      // Check if the local store exists
      if (localStorage.getItem('store')) {
        const localStore = JSON.parse(localStorage.getItem('store'));

        // Check the version stored against current. If different, don't
        // load the cached version
        if (localStore.version === version || !config.toolymctoolface.ignoreCache) {
          this.replaceState(Object.assign(wrkState, localStore));
        } else {
          wrkState.version = version;
        }
      }
    }
  }
});

// Subscribe to store updates
store.subscribe((mutation, state) => {
  const toStoreLocal = state;
  // Store the state object as a JSON string
  localStorage.setItem('store', JSON.stringify(toStoreLocal));
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js